import { FC } from "react"
import { SchedulesAdd } from "../../../module/schedules/containers/add"

export const SchedulesAddPage: FC = () => <SchedulesAdd />
